module.exports = {"pathContext":{}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/a-propos.json
// module id = 575
// module chunks = 258830403602296